import Vue from 'vue'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import Toasted from 'vue-toasted'
import VueApollo from 'vue-apollo'

import vuetify from '@/plugins/vuetify'
import '@/plugins/can'

import App from './App.vue'
import router from './router'
import store from './store'
import apolloClient from './utils/graphql/apolloClient'
import VueMapbox from "vue-mapbox";
import Mapbox from "mapbox-gl";
import Emitter from 'tiny-emitter';

Vue.prototype.$msalInstance = {};
Vue.prototype.$emitter = new Emitter();

Vue.config.productionTip = false

Vue.use(VueApollo)
Vue.use(Vuelidate)
Vue.use(Toasted, { router, duration: 5000, iconPack: 'material' })
Vue.use(VueGoogleMaps, {
  load: {
    // eslint-disable-next-line no-undef
    key: process.env.VUE_APP_KEY_GOOGLE_MAPS,
    libraries: 'places',
    region: 'BR',
    language: 'pt-br',
  },
  installComponents: true
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

Vue.use(VueMapbox, { mapboxgl: Mapbox });

new Vue({
  apolloProvider,
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
